import React, { useEffect } from 'react';
import { dispatch } from '../../bridge/events/dispatch';
import { DESTROY_CONTAINER } from '../../bridge/events/types';
import { renderAppointmentConfig } from '../../bridge/methods';
import { captureError } from '../../pages/captureError';

const APPOINTMENT_CONFIGS_CONTAINER_ID = 'APPOINTMENT_CONFIGS_CONTAINER_ID';

const AppointmentConfigsContainer: React.FC = () => {
    useEffect(() => {
        const configs = {
            containerId: APPOINTMENT_CONFIGS_CONTAINER_ID,
            routeParams: {},
            queryParams: '',
        };

        if (!window.RENDER_CONFIGS) {
            window.RENDER_CONFIGS = [];
        }

        window.RENDER_CONFIGS.push(configs);

        try {
            renderAppointmentConfig(configs);
        } catch (e) {
            console.log(e);
            captureError(e as Error);
        }
        return () => {
            dispatch({ type: DESTROY_CONTAINER, containerId: APPOINTMENT_CONFIGS_CONTAINER_ID });
            window.RENDER_CONFIGS = window.RENDER_CONFIGS?.filter(
                (renderConfig) => renderConfig.containerId !== APPOINTMENT_CONFIGS_CONTAINER_ID,
            );
        };
    }, []);
    return <div id={APPOINTMENT_CONFIGS_CONTAINER_ID} className="w-full"></div>;
};

export default AppointmentConfigsContainer;
